'use strict';

/**
 * @ngdoc service
 * @name prepApp.API
 * @description
 * # API
 * Create the factorys in the prepApp for API access.
 */

angular.module('prepApp')
    .factory('HotelService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'hotel/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('prepApp')
    .factory('TaskTemplateService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'tasktemplate/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('prepApp')
    .factory('CourseService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'course/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('prepApp')
    .factory('CourseTaskService', function ($resource, CONFIG) {
        return $resource(
            CONFIG.apiURL + 'coursetask/:id/', { id: '@id' }
            // Creates a PUT method defined as 'update'
            , {
                update: {
                    method: 'PUT',
                    params: { id: '@id' }
                }
            }
        );
    });

angular.module('prepApp')
    .service('APIs', function (TaskTemplateService, CourseService, CourseTaskService) {
        return {
            TaskTemplateService: TaskTemplateService,
            CourseService: CourseService,
            CourseTaskService: CourseTaskService
        };
    });
